export default class SetupHierarchyActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static ERROR_SERVER='ERROR_SERVER';
    static ERROR_DELETE='ERROR_DELETE';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static GET_HELPER_SETUP_HIERARCHY='GET_HELPER_SETUP_HIERARCHY';
    static SUCCESS_DATA='SUCCESS_DATA';
    static RESET_LIST='RESET_LIST';
  
    static submit(){
      return {
        type: SetupHierarchyActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: SetupHierarchyActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: SetupHierarchyActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: SetupHierarchyActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: SetupHierarchyActions.DELETE_DATA
      };
    }
    static resetList() {
      return {
        type: SetupHierarchyActions.RESET_LIST
      };
    }
    static list(data) {
      return {
        type: SetupHierarchyActions.SHOW_DATA,
        payload: data
      };
    }
    static error(error){
      return {
        type: SetupHierarchyActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: SetupHierarchyActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: SetupHierarchyActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: SetupHierarchyActions.RESET_DATA,
      };
    }
    static helper(data){
      return {
        type: SetupHierarchyActions.GET_HELPER_SETUP_HIERARCHY,
        payload:data
      };
    }
    static errorInternal(error){
      return {
        type: SetupHierarchyActions.ERROR_SERVER,
        payload: error
      };
    }
    static errorDelete(error){
      return {
        type: SetupHierarchyActions.ERROR_DELETE,
        payload: error
      };
    }
    
  }